import { material, systemWeights} from 'react-native-typography'

export const TypographyStyle = {
    ...material,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
}
export const TypographyWeightsStyle = systemWeights